module.exports = __webpack_public_path__ + "static/pivoting-ea8b5938cdc40ca449d9be6c26ed567f.gif";